import React, { createContext } from "react"
import { useStaticQuery, graphql } from "gatsby"

// Context作成
const RacketDataContext = createContext()

// Providerコンポーネント
const RacketDataProvider = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        filter: {
          internal: { contentFilePath: { regex: "/(/racket/)/" } }
          frontmatter: { is_competition: { ne: 2 } }
        }
      ) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            balance
            beam
            beam_mid
            beam_throat
            beam_top
            brand
            category
            channel
            channelId
            color
            youtubeId
            year
            weight
            title
            thumbnail {
              childImageSharp {
                gatsbyImageData
              }
            }
            technologies
            tags
            swingweight
            string_main
            string_cross
            slug
            size
            series
            name
            length
            jp
            description
            url
            amazon
            rakuten
            is_competition
          }
          internal {
            contentFilePath
          }
        }
      }
    }
  `)
  return (
    <RacketDataContext.Provider value={data}>
      {children}
    </RacketDataContext.Provider>
  )
}

export { RacketDataProvider, RacketDataContext }
